angular.module('dentalLinks')
    .controller('FromProviderController', ['$scope', 'User',
        function ($scope, User) {
            // list all providers from the practice.
            $scope.currentPracticeProviders = User.getProviders({practice_id: $scope.auth.practice_id});
        }
    ]);
